import React from "react";

import moment from "moment";

import { AutogenerateReportStrings } from "constants/constantStrings";
import { DATE_FORMAT, LOCAL_TIME_ZONE } from "constants/globalConstants";

import ToggleSwitch from "components/ToggleSwitch/ToggleSwitch";

import "./index.scss";

const hours = [
  "00:00",
  "01:00",
  "02:00",
  "03:00",
  "04:00",
  "05:00",
  "06:00",
  "07:00",
  "08:00",
  "09:00",
  "10:00",
  "11:00",
  "12:00",
  "13:00",
  "14:00",
  "15:00",
  "16:00",
  "17:00",
  "18:00",
  "19:00",
  "20:00",
  "21:00",
  "22:00",
  "23:00"
];
const monthdays = [
  "1st",
  "2nd",
  "3rd",
  "4th",
  "5th",
  "6th",
  "7th",
  "8th",
  "9th",
  "10th",
  "11th",
  "12th",
  "13th",
  "14th",
  "15th",
  "16th",
  "17th",
  "18th",
  "19th",
  "20th",
  "21st",
  "22nd",
  "23rd",
  "24th",
  "25th",
  "26th",
  "27th",
  "28th"
];

// const AutogenerateForm = ({ props, autogenerate, setAutogenerate, optionUpdated,  }) => {
const AutogenerateForm = ({ props, isAutoGenerateEnabled, setIsAutoGenerateEnabled }) => {
  //const [optionChecked, setOptionChecked] = useState((autogenerate && autogenerate.interval) || 'Daily');
  // const localTimeZone = LOCAL_TIME_ZONE;

  // useEffect(() => {
  //   if (optionUpdated) {
  //     setOptionChecked(autogenerate.interval);
  //     optionUpdated(autogenerate);
  //   }
  // }, [autogenerate]);

  // useEffect(() => {
  //   setAutogenerate({ ...autogenerate, timeZone: localTimeZone });
  // }, []);

  const onCheckChange = () => {
    setIsAutoGenerateEnabled(!isAutoGenerateEnabled);
    //const autoGenrate = autogenerate.enabled;
    // setAutogenerate({ ...autogenerate, enabled: !autoGenrate });
  };

  // const onValueChange = (event) => {
  //   const value = event.target.value;
  //   setOptionChecked(value);
  //   setAutogenerate({ ...autogenerate, interval: value, day: '', dayInputValue: '' });
  // };

  // const handleTimeStampChange = (key, inputKey, value, reason) => {
  //   if (reason === 'clear') {
  //     setAutogenerate({ ...autogenerate, [key]: '', [inputKey]: '' });
  //   } else if (reason === 'select-option') {
  //     setAutogenerate({ ...autogenerate, [key]: value, [inputKey]: value });
  //   }
  // };

  const getReportGenerationDayTime = () => {
    const day = moment().startOf("isoWeek").add(1, "week").day("sunday").format(DATE_FORMAT);
    const utcSundayTime = `${day} 00:00:00 UTC`;
    const dayTime = moment(utcSundayTime).format("dddd, hh:mm A");
    return `${dayTime} ${LOCAL_TIME_ZONE}`;
  };

  const getReportGenerationMsg = () => {
    const dayTime = getReportGenerationDayTime();
    return AutogenerateReportStrings.reportGenerationMsg.replace("%", dayTime);
  };

  return (
    <div>
      <div className="flex-between-center">
        <div className="autogenerate__title"> {AutogenerateReportStrings.autoGenerateSettings}</div>
        {/* <ToggleSwitch onChange={onCheckChange} checked={autogenerate.enabled} /> */}
        <ToggleSwitch onChange={onCheckChange} checked={isAutoGenerateEnabled} />
      </div>
      {/* {autogenerate.enabled && ( */}
      {isAutoGenerateEnabled && (
        <span className="bodySecondaryHeadingText">{getReportGenerationMsg()}</span>
        // <div>
        //   <div className="blackTextHeading">{AutogenerateReportStrings.interval}</div>
        //   <div className="flex-between marginTop10">
        //     <label className="radiocontainer">
        //       {AutogenerateReportStrings.daily}{' '}
        //       <input className="radioLabel" type="radio" value="Daily" onChange={onValueChange} checked={optionChecked === 'Daily'} />
        //       <span className="radioButton"> </span>{' '}
        //     </label>
        //     <label className="radiocontainer">
        //       {AutogenerateReportStrings.weekly}{' '}
        //       <input className="radioLabel" type="radio" value="Weekly" onChange={onValueChange} checked={optionChecked === 'Weekly'} />
        //       <span className="radioButton"> </span>{' '}
        //     </label>
        //     <label className="radiocontainer">
        //       {AutogenerateReportStrings.monthly}{' '}
        //       <input className="radioLabel" type="radio" value="Monthly" onChange={onValueChange} checked={optionChecked === 'Monthly'} />
        //       <span className="radioButton" checked={optionChecked === 'Monthly'}>
        //         {' '}
        //       </span>{' '}
        //     </label>
        //   </div>

        //   <InputBox customClass="margin-top-10-negative report-timezone" labelText="Timezone" disabled={true} value={localTimeZone} />

        //   <Dropdown
        //     customClass="report-timezone"
        //     labelText={AutogenerateReportStrings.hour}
        //     value={autogenerate.hour}
        //     options={hours}
        //     getOptionLabel={(option) => option}
        //     inputValue={autogenerate.hourInputValue}
        //     onChange={(value, reason) => handleTimeStampChange('hour', 'hourInputValue', value, reason)}
        //   />
        //   <Dropdown
        //     customClass="report-timezone "
        //     labelText={AutogenerateReportStrings.day}
        //     disabled={optionChecked === 'Daily' ? true : optionChecked === '' ? true : false}
        //     value={autogenerate.day}
        //     options={optionChecked === 'Weekly' ? Weekdays : monthdays}
        //     getOptionLabel={(option) => option}
        //     inputValue={autogenerate.dayInputValue}
        //     onChange={(value, reason) => handleTimeStampChange('day', 'dayInputValue', value, reason)}
        //   />
        // </div>
      )}
    </div>
  );
};

export default AutogenerateForm;
